// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__8Hn7F","shop":"Footer_shop__UBXps","icon":"Footer_icon__7qeIm","selective":"Footer_selective__ZtYAv","button":"Footer_button__A5FxO"};